"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
function ProductsConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-[400px] animate-pulse rounded-lg bg-muted/50" />)}
      </div>;
  }
  if (error) {
    return <div className="col-span-full py-20 text-center">
        <p className="text-destructive text-xl font-default">Error loading products. Please try again later.</p>
      </div>;
  }
  if (products.length === 0) {
    return <div className="col-span-full py-20 text-center">
        <p className="text-muted-foreground text-xl font-default">No products yet. Check back soon.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group bg-card border-border hover:border-primary hover:shadow-xl flex flex-col overflow-hidden rounded-lg border transition-all duration-300">
          {product.featured_image_url && <div className="aspect-square overflow-hidden bg-muted">
              <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
            </div>}
          <div className="flex flex-1 flex-col p-8 text-center">
            <h3 className="font-default text-foreground mb-2 text-xl font-bold">
              {product.title}
            </h3>
            <div className="mt-auto pt-4">
              <Link to="/ContactPage" className="bg-white text-primary border border-primary hover:bg-primary/5 inline-flex h-10 w-full items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors hover:opacity-90">
                Inquiry
              </Link>
              <Link to={product.link} className="mt-4 inline-block text-sm font-medium text-muted-foreground hover:text-primary transition-colors">
                View Details
              </Link>
            </div>
          </div>
        </div>)}
    </div>;
}
export default function OurPavingLandscapingExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const wp_query_params: any = {
    post_type: 'product',
    per_page: 12,
    status: 'publish'
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="222733" id="product-grid" className="bg-background text-foreground py-24 light">
      <div className="container mx-auto max-w-7xl px-4 md:px-8">
        <div className="mb-16 text-center">
          <h2 className="font-default text-foreground mb-4 text-3xl font-bold md:text-4xl lg:text-5xl">
            Our Products
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg">
            Explore our curated selection of premium paving and landscaping materials, sourced for durability and aesthetic excellence.
          </p>
        </div>

        <div ref={ref} className={`transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
          <EcommerceProductsProvider wp_query={wp_query}>
            <ProductsConsumer />
          </EcommerceProductsProvider>
        </div>
      </div>
    </section>;
}